export enum Colors {
  Y100 = '#FEE250',
  Y200 = '#EBD14A',
  Y300 = '#D6BF43',
  Y400 = '#C2AD3D',
  Y500 = '#AD9B36',

  G100 = '#E1E8F6',
  G200 = '#CDD4E0',
  G300 = '#BBC1CC',
  G400 = '#A8AEB8',
  G500 = '#959AA3',

  N100 = '#FFFFFF',
  N200 = '#6B6B6E',
  N300 = '#575759',
  N400 = '#434345',
  N500 = '#2F2F30',
  N600 = '#1B1B1C',
}

export default Colors;
